import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  link: {
    marginBottom: '2rem',
  },
  veevaNumber: {
    position: 'absolute',
    top: '0.25rem',
    left: '0.25rem',
    color: 'rgba(34, 34, 34, 0.1)',
    fontSize: '0.625rem',
    lineHeight: 1.1,
  },
}));
